export const Font = {
  Montserrat: ['"Montserrat"', 'sans-serif'].join(','),
};
